const get = (key: string, parse?: boolean) => {
  const item = window.localStorage.getItem(key);

  return parse ? JSON.parse(item) : item;
};

const set = (key: string, value: string) => {
  window.localStorage.setItem(key, value);
};

const remove = (key: string) => {
  window.localStorage.removeItem(key);
};

const clear = () => {
  window.localStorage.clear();
};

export const localStorage = {
  get,
  set,
  remove,
  clear,
};
